import { fieldTypes } from "@/components/riskTemplateBuilder/config";

/*
  Normilizes a template "flat" to a schema  Vue Formulate with:
  -- Sections and subsections (detected by headers or by f.section/f.subsection)
  -- Visibility with conditional show_if (same section and previous questions)
  -- Conditional comments by section (select and checkbox)
  -- File Sections (file_section)
  -- Comments of review by question (just visible in in_review/finals; editable just by revisor in in_review)
*/
export default class RiskFormNormalizer {
  constructor(vm, templateFields, options = {}) {
    console.log("RiskFormalizerJS - Options", { options });
    this.vm = vm;
    this.templateFields = templateFields || [];
    this.options = options;
    this.customComponents = options.customComponents || {};
    this.model = options.model || {};
    this.currentState = options.currentState || "in_progress";
    this.isReviewer = !!options.isReviewer;
    this.onUpdateFiles = options.onUpdateFiles || null;
    this.onUpdateComments = options.onUpdateComments || null;
    this.onAddComment = options.onAddComment || null;
  }

  convertFieldType(type) {
    const fieldType = fieldTypes.find((fType) => fType.type === type);
    return fieldType ? fieldType.data_type : "text";
  }

  answerKey(field) {
    return field && field.item_id != null && field.item_id !== ""
      ? String(field.item_id)
      : field && field.name;
  }

  getAnswer(model, field) {
    if (!model || !field) return undefined;
    const key = this.answerKey(field);
    if (Object.prototype.hasOwnProperty.call(model, key)) return model[key];
    if (field.name && Object.prototype.hasOwnProperty.call(model, field.name)) {
      return model[field.name];
    }
    return undefined;
  }

  derivedKey(field, suffix) {
    return `${this.answerKey(field)} - ${suffix}`;
  }

  getDerived(model, field, suffix) {
    if (!model || !field) return undefined;
    const key = this.derivedKey(field, suffix);
    if (Object.prototype.hasOwnProperty.call(model, key)) return model[key];
    const legacyKey = `${field.name} - ${suffix}`;
    if (Object.prototype.hasOwnProperty.call(model, legacyKey)) return model[legacyKey];
    return undefined;
  }

  static hydrateLegacyAnswers(templateFields, model) {
    if (!model || typeof model !== "object") return model;
    const fields = Array.isArray(templateFields) ? templateFields : [];

    const copy = (fromKey, toKey) => {
      if (!fromKey || !toKey || fromKey === toKey) return;
      if (Object.prototype.hasOwnProperty.call(model, toKey)) return;
      if (Object.prototype.hasOwnProperty.call(model, fromKey)) {
        model[toKey] = model[fromKey];
      }
    };

    fields.forEach((f) => {
      if (!f || f.type === "section_header" || f.type === "subsection_header") return;
      const itemKey =
        f.item_id != null && f.item_id !== "" ? String(f.item_id) : f.name;
      if (!itemKey || !f.name) return;

      copy(f.name, itemKey);

      const opts = ((f.options || {}).fieldTypeCfg || {}).data || [];
      if (f.type === "select") {
        copy(`${f.name} - comment`, `${itemKey} - comment`);
      } else if (f.type === "checkbox") {
        opts.forEach((o) =>
          copy(`${f.name} - ${o.name} - comment`, `${itemKey} - ${o.name} - comment`)
        );
      } else if (f.type === "duration_hm") {
        copy(`${f.name} - horas`, `${itemKey} - horas`);
        copy(`${f.name} - minutos`, `${itemKey} - minutos`);
      } else if (f.type === "duration_ms") {
        copy(`${f.name} - minutos`, `${itemKey} - minutos`);
        copy(`${f.name} - segundos`, `${itemKey} - segundos`);
      }
      copy(`review_comments_${f.name}`, `review_comments_${itemKey}`);
    });

    return model;
  }
  buildGroup() {
    return { component: "div", class: "mt-3", children: [] };
  }
  buildButton(opts = {}) {
    return {
      component: "button",
      name: opts.name,
      type: opts.type,
      disabled: opts.disabled,
      children: [{ component: "span", children: opts.text }],
      class: Array.isArray(opts.classes)
        ? opts.classes.join(" ")
        : [opts.classes].join(" "),
    };
  }
  slugify(s) {
    return String(s || "")
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");
  } // one-liner
  _normTxt(s) {
    return String(s || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .trim();
  } // one-liner

  isFinalState() {
    const st = String(this.currentState || "").toLowerCase();
    return ["approved", "rejected", "canceled", "cancelled"].includes(st);
  }
  canEdit() {
    //father sends disabled / canEdit
    if (this.options.disabled === true) return false;
    if (typeof this.options.canEdit === "boolean") return this.options.canEdit;

    const st = String(this.currentState || "").toLowerCase();

    // final states just read
    if (["approved", "rejected", "canceled", "cancelled"].includes(st)) return false;

    //In review just assigned cames from father
    if (st === "in_review") {
      return !!this.isReviewer;
    }
    //In progress/ reassigned editable check just owner cames from modal
    if (st === "in_progress" || st === "reassigned") return true;

    //other states nopt editables
    return false;
  }
  isFormLocked() {
    if (this.options.alwaysEditable) return false;
    return !this.canEdit();
  }
  showReviewComments() {
    const s = String(this.currentState || "").toLowerCase();
    return s === "in_review" || s === "reassigned" || this.isFinalState();
  }
  reviewCommentsDisabled() {
    if (this.currentState === "in_review") return !this.isReviewer;
    return true;
  }

  cfg(field) {
    const raw =
      field?.options?.fieldTypeCfg?.config || field?.options?.fieldTypeCfg || {};
    const fromArray = Array.isArray(field?.options?.fieldTypeCfg?.data)
      ? field.options.fieldTypeCfg.data.reduce((acc, it) => {
          if (it && it.key) acc[it.key] = it.default ?? null;
          return acc;
        }, {})
      : {};
    const base = { ...fromArray, ...raw };

    if (field.type === "numeric") {
      return {
        decimals: Number(base.decimals ?? 0) || 0,
        min: base.min ?? null,
        max: base.max ?? null,
        allowNegative: !!base.allowNegative,
      };
    }

    if (field.type === "time_hhmm") {
      return { min: base.min ?? null, max: base.max ?? null };
    }

    if (field.type === "minutes") {
      return { min: base.min ?? 0, max: base.max ?? null };
    }

    if (field.type === "duration_hm") {
      return {
        minHours: base.minHours ?? 0,
        maxHours: base.maxHours ?? null,
        minMinutes: 0,
        maxMinutes: 59,
      };
    }

    if (field.type === "duration_ms") {
      return {
        minMinutes: base.minMinutes ?? 0,
        maxMinutes: base.maxMinutes ?? null,
        minSeconds: 0,
        maxSeconds: 59,
      };
    }

    if (field.type === "duration_hms") {
      return {
        maxHours: base.maxHours ?? 24,
        minHours: 0,
        minMinutes: 0,
        maxMinutes: 59,
        minSeconds: 0,
        maxSeconds: 59,
      };
    }

    return {};
  }

  numberStep(dec) {
    const d = Number(dec || 0);
    return d > 0 ? Number("0." + "0".repeat(d - 1) + "1") : 1;
  }

  getProcessedFields() {
    const out = [];
    const secLabelNone = this.vm.$t("risk.template.no_section") || "Sin sección";

    let currentSection = null;
    let currentSubsection = null;

    const list = Array.isArray(this.templateFields) ? this.templateFields : [];

    for (const raw of list) {
      const f = { ...raw };

      if (typeof f.section !== "undefined") {
        currentSection = f.section || secLabelNone;
        if (typeof f.subsection !== "undefined") currentSubsection = f.subsection || null;
        if (f.type === "section_header" || f.type === "subsection_header") continue;
      }

      if (f.type === "section_header") {
        const lvl = Number((f.options && f.options.level) || 1);
        if (lvl === 1) {
          currentSection = f.name || secLabelNone;
          currentSubsection = null;
        } else {
          currentSubsection = f.name || null;
        }
        continue;
      }
      if (f.type === "subsection_header") {
        currentSubsection = f.name || null;
        continue;
      }

      if (!f.section) f.section = currentSection || secLabelNone;
      if (typeof f.subsection === "undefined") f.subsection = currentSubsection || null;

      out.push(f);
    }

    return out;
  }

  groupBySection(fields) {
    const secLabelNone = this.vm.$t("risk.template.no_section") || "Sin sección";
    const groups = new Map();
    const order = [];
    (fields || []).forEach((f) => {
      const key = f.section || secLabelNone;
      if (!groups.has(key)) {
        groups.set(key, { fields: [] });
        order.push(key);
      }
      groups.get(key).fields.push({ ...f });
    });
    return { order, groups, secLabelNone };
  }

  groupBySectionSubsection(fields) {
    const { order, groups } = this.groupBySection(fields);
    const structured = new Map();

    order.forEach((secName) => {
      const { fields: secFields } = groups.get(secName) || { fields: [] };
      const entry = { root: [], sub: new Map(), subOrder: [] };

      secFields.forEach((f) => {
        const sub = f.subsection || null;
        if (!sub) {
          entry.root.push(f);
          return;
        }
        if (!entry.sub.has(sub)) {
          entry.sub.set(sub, []);
          entry.subOrder.push(sub);
        }
        entry.sub.get(sub).push(f);
      });

      structured.set(secName, entry);
    });

    return { order, structured, groups };
  }

  isFieldVisible(field, sectionFields, indexInSection, answers) {
    const conds = Array.isArray(field.show_if) ? field.show_if : [];
    const logic = field.show_logic === "any" ? "any" : "all";
    if (!conds.length) return true;

    const idToIndex = new Map((sectionFields || []).map((f, idx) => [f.item_id, idx]));
    const getAnsByItemId = (itemId) => {
      const idx = idToIndex.has(itemId) ? idToIndex.get(itemId) : -1;
      if (idx === -1) return { exists: false, value: undefined, idx: -1, field: null };
      const ref = sectionFields[idx];
      return {
        exists: true,
        idx,
        field: ref,
        value: answers ? this.getAnswer(answers, ref) : undefined,
      };
    };

    const asArray = (v) =>
      Array.isArray(v) ? v : v === undefined || v === null || v === "" ? [] : [v];
    const same = (a, b) => {
      if (Array.isArray(a) || Array.isArray(b)) {
        const aa = asArray(a).map((x) => JSON.stringify(x));
        const bb = asArray(b).map((x) => JSON.stringify(x));
        if (aa.length !== bb.length) return false;
        const setB = new Set(bb);
        return aa.every((x) => setB.has(x));
      }
      return String(a) === String(b);
    };
    const num = (v) =>
      v === "" || v === null || typeof v === "undefined" ? NaN : Number(v);
    const contains = (arr, v) =>
      (arr || []).map((x) => JSON.stringify(x)).includes(JSON.stringify(v));

    const evalOne = (c) => {
      if (!c || !c.field) return false;
      const ref = getAnsByItemId(c.field);
      if (!ref.exists) return false;
      if (ref.idx >= indexInSection) return false;

      const ans = ref.value;
      switch (c.op) {
        case "truthy":
          return !!ans;
        case "falsy":
          return !ans;
        case "==":
          return same(ans, c.value);
        case "!=":
          return !same(ans, c.value);
        case ">":
          return num(ans) > num(c.value);
        case ">=":
          return num(ans) >= num(c.value);
        case "<":
          return num(ans) < num(c.value);
        case "<=":
          return num(ans) <= num(c.value);
        case "in": {
          const arr = asArray(ans),
            vals = asArray(c.value);
          return arr.some((v) => contains(vals, v));
        }
        case "includes_all": {
          const arr = asArray(ans),
            vals = asArray(c.value);
          return vals.every((v) => contains(arr, v));
        }
        case "not_in": {
          const arr = asArray(ans),
            vals = asArray(c.value);
          return vals.every((v) => !contains(arr, v));
        }
        default:
          return false;
      }
    };

    const res = conds.map(evalOne);
    return logic === "any" ? res.some(Boolean) : res.every(Boolean);
  }

  visibleFileLabels(answersObj = {}) {
    const labels = new Set();
    const fields = this.getProcessedFields().filter((f) => {
      if (!this.options.showAlarmsOnly) return true;
      return !!(f && f.options && f.options.alarms === true);
    });

    const { order, groups } = this.groupBySection(fields);
    order.forEach((secName) => {
      const sec = groups.get(secName);
      (sec.fields || []).forEach((f, idx) => {
        if (
          f.type === "files_section" &&
          this.isFieldVisible(f, sec.fields, idx, answersObj)
        ) {
          labels.add(this.answerKey(f));
        }
      });
    });

    return labels;
  }

  pruneModelInvisible(model = {}) {
    const pruned = { ...(model || {}) };
    const fields = this.getProcessedFields().filter((f) => {
      if (!this.options.showAlarmsOnly) return true;
      return !!(f && f.options && f.options.alarms === true);
    });

    fields.forEach((f) => {
      const itemKey = this.answerKey(f);
      this._migrateKey(pruned, f.name, itemKey);

      const opts = ((f.options || {}).fieldTypeCfg || {}).data || [];
      if (f.type === "select") {
        this._migrateKey(pruned, `${f.name} - comment`, `${itemKey} - comment`);
      } else if (f.type === "checkbox") {
        opts.forEach((o) =>
          this._migrateKey(
            pruned,
            `${f.name} - ${o.name} - comment`,
            `${itemKey} - ${o.name} - comment`
          )
        );
      } else if (f.type === "duration_hm") {
        this._migrateKey(pruned, `${f.name} - horas`, `${itemKey} - horas`);
        this._migrateKey(pruned, `${f.name} - minutos`, `${itemKey} - minutos`);
      } else if (f.type === "duration_ms") {
        this._migrateKey(pruned, `${f.name} - minutos`, `${itemKey} - minutos`);
        this._migrateKey(pruned, `${f.name} - segundos`, `${itemKey} - segundos`);
      }
      this._migrateKey(
        pruned,
        `review_comments_${f.name}`,
        `review_comments_${itemKey}`
      );
    });

    const { order, groups } = this.groupBySection(fields);

    order.forEach((secName) => {
      const sec = groups.get(secName);
      const secFields = sec.fields || [];

      secFields.forEach((f, idx) => {
        const itemKey = this.answerKey(f);
        const visible = this.isFieldVisible(f, secFields, idx, pruned);
        if (!visible) {
          if (pruned.hasOwnProperty(itemKey)) delete pruned[itemKey];

          const opts = ((f.options || {}).fieldTypeCfg || {}).data || [];
          if (f.type === "select") {
            const cKey = `${itemKey} - comment`;
            if (pruned.hasOwnProperty(cKey)) delete pruned[cKey];
          } else if (f.type === "checkbox") {
            opts.forEach((o) => {
              const cKey = `${itemKey} - ${o.name} - comment`;
              if (pruned.hasOwnProperty(cKey)) delete pruned[cKey];
            });
          }
          if (f.type === "duration_hm") {
            const hKey = `${itemKey} - horas`;
            const mKey = `${itemKey} - minutos`;
            if (pruned.hasOwnProperty(hKey)) delete pruned[hKey];
            if (pruned.hasOwnProperty(mKey)) delete pruned[mKey];
          }

          if (f.type === "duration_ms") {
            const mKey = `${itemKey} - minutos`;
            const sKey = `${itemKey} - segundos`;
            if (pruned.hasOwnProperty(mKey)) delete pruned[mKey];
            if (pruned.hasOwnProperty(sKey)) delete pruned[sKey];
          }

          if (f.type === "files_section" && pruned.hasOwnProperty(itemKey)) {
            delete pruned[itemKey];
          }
          return;
        }

        const opts = ((f.options || {}).fieldTypeCfg || {}).data || [];
        if (f.type === "select") {
          const sel = pruned[itemKey];
          const opt = opts.find((o) => o && o.name === sel);
          const needComment = !!(opt && opt.allowComment);
          const cKey = `${itemKey} - comment`;
          if (!needComment && pruned.hasOwnProperty(cKey)) delete pruned[cKey];
        } else if (f.type === "checkbox") {
          const arr = Array.isArray(pruned[itemKey]) ? pruned[itemKey] : [];
          const needSet = new Set(
            opts
              .filter((o) => o && o.allowComment && arr.includes(o.name))
              .map((o) => `${itemKey} - ${o.name} - comment`)
          );
          opts.forEach((o) => {
            const key = `${itemKey} - ${o.name} - comment`;
            if (!needSet.has(key) && pruned.hasOwnProperty(key)) delete pruned[key];
          });
        }
      });
    });

    return pruned;
  }

  _migrateKey(obj, fromKey, toKey) {
    if (!fromKey || !toKey || fromKey === toKey) return;
    if (!Object.prototype.hasOwnProperty.call(obj, fromKey)) return;
    if (!Object.prototype.hasOwnProperty.call(obj, toKey)) {
      obj[toKey] = obj[fromKey];
    }
    delete obj[fromKey];
  }

  makeFieldNodes(field, fieldIndex) {
    const locked = this.isFormLocked();
    const itemKey = this.answerKey(field);

    if (field.type === "files_section") {
      const fileField = {
        id: field.item_id,
        name: itemKey,
        label: field.name,
        type: "component",
        component: this.customComponents.FileUploadWithPreview,
        existingFiles: this.getAnswer(this.model, field) || [],
        disabled: locked,
        uploading: this.options.uploadingFieldLabel === itemKey,
        deleting: this.options.deletingFieldLabel === itemKey,
        onUpdateFiles: this.onUpdateFiles,
      };
      return [fileField, { component: "hr", class: "field-divider my-4" }];
    }

    if (field.type === "users" && this.customComponents.UserPickerInput) {
      return [
        {
          id: field.item_id,
          name: itemKey,
          label: field.name,
          type: "component",
          component: this.customComponents.UserPickerInput,
          value: this.getAnswer(this.model, field) || null,
          disabled: locked,
          onUpdateValue: (value) => {
            if (this.vm) {
              this.vm.$set(this.vm.model, itemKey, value);
            }
            this.model[itemKey] = value;
            if (this.vm && this.vm._onModelTouched) {
              this.vm._onModelTouched();
            }
          },
        },
        { component: "hr", class: "field-divider my-4" },
      ];
    }

    if (field.type === "units" && this.customComponents.UnitPickerInput) {
      return [
        {
          id: field.item_id,
          name: itemKey,
          label: field.name,
          type: "component",
          component: this.customComponents.UnitPickerInput,
          value: this.getAnswer(this.model, field) || null,
          disabled: locked,
          onUpdateValue: (value) => {
            if (this.vm) {
              this.vm.$set(this.vm.model, itemKey, value);
            }
            this.model[itemKey] = value;
            if (this.vm && this.vm._onModelTouched) {
              this.vm._onModelTouched();
            }
          },
        },
        { component: "hr", class: "field-divider my-4" },
      ];
    }

    let fieldOptions;
    if (["select", "checkbox"].includes(field.type)) {
      const rawOptions =
        field.options &&
        field.options.fieldTypeCfg &&
        Array.isArray(field.options.fieldTypeCfg.data)
          ? field.options.fieldTypeCfg.data
          : [];

      fieldOptions = rawOptions.map(
        (o, i) =>
          [
            {
              label: o.name || `Option_${fieldIndex}_${i}`,
              value: o.name || `Option_${fieldIndex}_${i}`,
              allowComment: !!o.allowComment,
            },
          ][0]
      );
    }

    const mainField = {
      id: field.item_id,
      name: itemKey,
      label: field.name,
      type: this.convertFieldType(field.type),
      disabled: locked,
      validation: field.options && field.options.required ? "required" : "",
      options: fieldOptions,
    };

    if (field.type === "select") {
      mainField.placeholder = this.vm.$t?.("maintenance.select") || "Select";
    }

    if (field.type === "date") {
      mainField.type = "customDate";
      mainField.fieldOptions = {
        fieldTypeCfg: { data: [{ format: { value: "d/m/Y" } }] },
      };
    }

    if (field.type === "time_hhmm") {
      const { min, max } = this.cfg(field);
      mainField.type = "time";
      mainField.attrs = {
        step: 60,
        lang: "es-ES",
        ...(min ? { min } : {}),
        ...(max ? { max } : {}),
      };
    }

    if (field.type === "numeric") {
      const { decimals, min, max, allowNegative } = this.cfg(field);
      const step = this.numberStep(decimals);
      const pattern =
        decimals > 0
          ? allowNegative
            ? "^-?\\d+(\\.\\d+)?$"
            : "^\\d+(\\.\\d+)?$"
          : allowNegative
          ? "^-?\\d+$"
          : "^\\d+$";
      mainField.type = "number";
      mainField.attrs = {
        step,
        inputmode: decimals > 0 ? "decimal" : "numeric",
        pattern,
        ...(min !== null ? { min } : {}),
        ...(max !== null ? { max } : {}),
      };
    }

    if (field.type === "minutes") {
      const { min, max } = this.cfg(field);
      mainField.type = "number";
      mainField.attrs = {
        step: 1,
        inputmode: "numeric",
        pattern: "^\\d+$",
        ...(min !== null ? { min } : { min: 0 }),
        ...(max !== null ? { max } : {}),
      };
    }

    if (field.type === "duration_hm") {
      const { minHours, maxHours, minMinutes, maxMinutes } = this.cfg(field);
      const nodes = [];

      nodes.push({
        component: "div",
        class: "duration-hm-row",
        children: [
          {
            name: `${itemKey} - horas`,
            label: `${field.name} (horas)`,
            type: "number",
            disabled: locked,
            validation: field.options?.required ? "required" : "",
            attrs: {
              step: 1,
              min: minHours ?? 0,
              ...(maxHours !== null ? { max: maxHours } : {}),
              inputmode: "numeric",
              pattern: "^\\d+$",
            },
          },
          {
            name: `${itemKey} - minutos`,
            label: `${field.name} (minutos)`,
            type: "number",
            disabled: locked,
            validation:
              `between:${minMinutes},${maxMinutes}` +
              (field.options?.required ? "|required" : ""),
            attrs: {
              step: 1,
              min: minMinutes ?? 0,
              max: maxMinutes ?? 59,
              inputmode: "numeric",
              pattern: "^\\d+$",
            },
          },
        ],
      });

      nodes.push({ component: "hr", class: "field-divider my-4" });
      return nodes;
    }

    const nodes = [mainField];

    if (field.type === "duration_ms") {
      const c = typeof this.cfg === "function" ? this.cfg(field) : {};
      const minMinutes = c.minMinutes ?? 0;
      const maxMinutes = c.maxMinutes ?? null;
      const minSeconds = c.minSeconds ?? 0;
      const maxSeconds = c.maxSeconds ?? 59;

      const nodes = [];

      nodes.push({
        component: "div",
        class: "duration-hm-row",
        children: [
          {
            name: `${itemKey} - minutos`,
            label: `${field.name} (minutos)`,
            type: "number",
            disabled: locked,
            validation: field.options?.required ? "required" : "",
            attrs: {
              step: 1,
              min: minMinutes,
              ...(maxMinutes !== null ? { max: maxMinutes } : {}),
              inputmode: "numeric",
              pattern: "^\\d+$",
            },
          },
          {
            name: `${itemKey} - segundos`,
            label: `${field.name} (segundos)`,
            type: "number",
            disabled: locked,
            validation:
              `min:${minSeconds}|max:${maxSeconds}` +
              (field.options?.required ? "|required" : ""),
            attrs: {
              step: 1,
              min: minSeconds,
              max: maxSeconds,
              inputmode: "numeric",
              pattern: "^\\d+$",
            },
          },
        ],
      });

      nodes.push({ component: "hr", class: "field-divider my-4" });
      return nodes;
    }

    if (field.type === "duration_hms") {
      const c = typeof this.cfg === "function" ? this.cfg(field) : {};
      const maxHours = c.maxHours ?? 24;

      const durationField = {
        name: itemKey,
        label: `${field.name} (HH:MM:SS)`,
        type: "component",
        component: this.customComponents.DurationHmsInput,
        disabled: locked,
        maxHours: maxHours,
        value: this.getAnswer(this.model, field) || { hours: 0, minutes: 0, seconds: 0 },
        onUpdateValue: (value) => {
          if (this.vm) {
            this.vm.$set(this.vm.model, itemKey, value);
            this.model[itemKey] = value;
            if (this.vm._onModelTouched) {
              this.vm._onModelTouched();
            }
          } else {
            this.model[itemKey] = value;
          }
        },
      };

      return [durationField, { component: "hr", class: "field-divider my-4" }];
    }

    const opts = Array.isArray(fieldOptions) ? fieldOptions : [];
    if (field.type === "select") {
      const sel = this.getAnswer(this.model, field);
      const match = opts.find((o) => o.value === sel);
      if (match && match.allowComment) {
        nodes.push({
          name: `${itemKey} - comment`,
          label: `${this.vm.$t("risk.comment")}`,
          type: "textarea",
          disabled: locked,
        });
      }
    } else if (field.type === "checkbox") {
      const selArrRaw = this.getAnswer(this.model, field);
      const selArr = Array.isArray(selArrRaw) ? selArrRaw : [];
      opts
        .filter((o) => o.allowComment && selArr.includes(o.value))
        .forEach((o) => {
          nodes.push({
            name: `${itemKey} - ${o.value} - comment`,
            label: `${this.vm.$t("risk.comment")}`,
            type: "textarea",
            disabled: locked,
          });
        });
    }

    if (this.showReviewComments() && this.customComponents.ReviewCommentsWithPreview) {
      const rcKey = `review_comments_${itemKey}`;
      const legacyRcKey = `review_comments_${field.name}`;
      const existingComments = this.model[rcKey] || this.model[legacyRcKey] || [];

      nodes.push({
        name: rcKey,
        type: "component",
        component: this.customComponents.ReviewCommentsWithPreview,
        existingComments,
        id: rcKey,
        disabled: this.reviewCommentsDisabled(),
        onAddComment: this.onAddComment,
        onUpdateComments: ({ label, comments }) => {
          if (this.onUpdateComments) this.onUpdateComments({ label, comments });
          const allFiles = (comments || []).flatMap((c) =>
            Array.isArray(c.files) ? c.files : []
          );
          if (this.onUpdateFiles) {
            this.onUpdateFiles({ label: rcKey, files: allFiles });
          }
        },
      });
    }

    nodes.push({ component: "hr", class: "field-divider my-4" });
    return nodes;
  }

  convert() {
    const schema = [];

    const processed = this.getProcessedFields().filter((f) => {
      if (!this.options.showAlarmsOnly) return true;
      return !!(f && f.options && f.options.alarms === true);
    });

    const { order, groups } = this.groupBySection(processed);
    const { structured } = this.groupBySectionSubsection(processed);

    const noNaItems = [];

    order.forEach((secName) => {
      const secFields = (groups.get(secName) || {}).fields || [];
      const indexMap = new Map(secFields.map((f, idx) => [f.item_id, idx]));

      const entry = structured.get(secName) || { root: [], sub: new Map(), subOrder: [] };

      const sectionChildren = [];
      let sectionVisibleCount = 0;

      const pushNoNa = (f) => {
        const v = this.model ? this.getAnswer(this.model, f) : undefined;
        if (v == null) return;
        const toArr = (x) => (Array.isArray(x) ? x : [x]);
        const hits = toArr(v).map((x) => this._normTxt(x));
        if (hits.includes("no") || hits.includes("no aplica")) {
          const comment = this.model ? String(this.getDerived(this.model, f, "comment") || "") : "";
          noNaItems.push({ name: f.name, section: secName, comment });
        }
      };

      const rootNodes = [];
      let rootVisible = 0;
      (entry.root || []).forEach((f) => {
        const idx = indexMap.get(f.item_id) ?? 0;
        if (!this.isFieldVisible(f, secFields, idx, this.model)) return;
        rootNodes.push(...this.makeFieldNodes(f, idx));
        rootVisible += 1;
        if (["select", "radio", "checkbox"].includes(f.type)) pushNoNa(f);
      });
      if (rootVisible) {
        sectionChildren.push(...rootNodes);
        sectionVisibleCount += rootVisible;
      }

      const subOrder = entry.subOrder || [];
      subOrder.forEach((subName) => {
        const subNodes = [];
        let subVisible = 0;

        const items = entry.sub.get(subName) || [];
        items.forEach((f) => {
          const idx = indexMap.get(f.item_id) ?? 0;
          if (!this.isFieldVisible(f, secFields, idx, this.model)) return;
          subNodes.push(...this.makeFieldNodes(f, idx));
          subVisible += 1;
          if (["select", "radio", "checkbox"].includes(f.type)) pushNoNa(f);
        });
        if (!subVisible) return;

        const cleaned =
          subNodes.length && subNodes[subNodes.length - 1].component === "hr"
            ? subNodes.slice(0, -1)
            : subNodes;

        const anchorId = `sub-${this.slugify(secName)}-${this.slugify(subName)}`;
        const cls = `rfm-anchor rfm-aid-${anchorId} rfm-sub-${this.slugify(
          secName
        )}-${this.slugify(subName)}`;
        sectionChildren.push({
          component: "div",
          class: cls,
          children: [
            {
              component: this.customComponents.SectionGroup || "div",
              title: subName,
              count: subVisible,
              initiallyCollapsed: false,
              level: 2,
              children: cleaned,
            },
          ],
        });
        sectionVisibleCount += subVisible;
      });

      if (!sectionVisibleCount) return;

      if (
        sectionChildren.length &&
        sectionChildren[sectionChildren.length - 1].component === "hr"
      ) {
        sectionChildren.pop();
      }

      const secAnchorId = `sec-${this.slugify(secName)}`;
      const clsSec = `rfm-anchor rfm-aid-${secAnchorId} rfm-sec-${this.slugify(secName)}`;
      schema.push({
        component: "div",
        class: clsSec,
        children: [
          {
            component: this.customComponents.SectionGroup || "div",
            title: secName,
            count: sectionVisibleCount,
            initiallyCollapsed: false,
            level: 1,
            children: sectionChildren,
          },
        ],
      });
    });

    // if (noNaItems.length) {
    //   const listNodes = noNaItems.map((it) => ({
    //     component: "div",
    //     class: "no-na-item",
    //     children: [
    //       { component: "div", class: "font-weight-600", children: it.name },
    //       it.comment
    //         ? { component: "div", class: "text-muted small", children: it.comment }
    //         : null,
    //     ].filter(Boolean),
    //   }));

    //   const box = {
    //     component: "div",
    //     class: "no-na-box",
    //     children: listNodes,
    //   };

    //   const anchorId = "sec-no-na";
    //   const cls = `rfm-anchor rfm-aid-${anchorId} rfm-sec-no-na`;
    //   schema.push({
    //     component: "div",
    //     class: cls,
    //     children: [
    //       {
    //         component: this.customComponents.SectionGroup || "div",
    //         title:
    //           this.vm.$t("risk.no_na_title") ||
    //           "Preguntas con respuesta: No / No aplica",
    //         count: noNaItems.length,
    //         initiallyCollapsed: false,
    //         level: 1,
    //         children: [box],
    //       },
    //     ],
    //   });
    // }

    //just show save button when the form is editable
    let shouldShowSave = this.canEdit() && this.options.externalSave !== true;
    if (shouldShowSave) {
      try {
        const path = String(this.vm?.$route?.path || "").toLowerCase();
        //In the risk evaluation view the save is controlled by the modal
        if (path.startsWith("/risk/evaluations")) shouldShowSave = false;
      } catch (_) {}
    }
    if (shouldShowSave) {
      const buttonGroup = this.buildGroup();
      buttonGroup.children.push(
        this.buildButton({
          name: "submit",
          type: "submit",
          text: this.vm.$t?.("actions.save") || "Save",
          classes: ["btn", "btn-primary", "text-uppercase", "mr-1"],
          disabled: false,
        })
      );
      schema.push(buttonGroup);
    }

    return schema;
  }
}
